import { Box, Typography } from '@material-ui/core'
import React from 'react'
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar'
import { makeStyles } from '@material-ui/core/styles';
//import Box from '@material-ui/core/Box';
const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    small: {
      width: theme.spacing(30),
      height: theme.spacing(30),
    },
    large: {
      width: theme.spacing(7),
      height: theme.spacing(7),
      color : "black"
    },
    text : {
      color : 'white'
    },
    headline : {
      color : '#c92828'
    },
    desciptionText : {
      color : '#379683'
    }
  }));

  const defaultProps = {
    bgcolor: 'background.paper',
    borderColor: 'text.primary',
    m: 10,
    p : 1,
    border: 2,
    style: { width: '15rem', height: '15rem' },
  };

  const nameProps = {
    p : 2,
    style :{
      marginTop : 100
    }
  };
 
function Name(props) {
    const classes = useStyles();
    return (
        <div>
            <Grid container justify="center">
                <Grid item  xs={12} md={5}>
                <Box display="flex" justifyContent="center">
                <Box borderRadius="50%" {...defaultProps}>
                  <Avatar 
                      alt={props.alt}
                      src={props.avatar} 
                      className={classes.small} />
                </Box>
                </Box>
                
                </Grid>
                <Grid item xs={12} md={7}>
                  <Box {...nameProps}>
                    <Typography variant="h5" gutterBottom className={classes.text}>
                      Welcome I'm
                    </Typography>
                    <Typography variant="h2" gutterBottom className={classes.headline}>
                      {props.alt}
                    </Typography>
                    <Typography gutterBottom variant="h6" className={classes.desciptionText}>
                      {props.bio!==null?`${props.bio},`: ''}
                    </Typography>
                    <Typography gutterBottom variant="h6" className={classes.desciptionText}>
                      {props.company!==null?`${props.company},`: ''}
                    </Typography>
                    <Typography variant="h6" gutterBottom className={classes.desciptionText}>
                    {props.location!==null?`${props.location},`: ''}
                    </Typography>
                    <Typography variant="h6" gutterBottom className={classes.desciptionText}>
                    {props.website!==""?`${props.website},`: ''}
                    </Typography>
                    <Typography variant="h6" gutterBottom className={classes.desciptionText}>
                    {props.followers!==null?
                    `${props.followers} Followers.. ` 
                    : ''}
                    </Typography>
                  </Box>
                    
                </Grid>
            </Grid>
        </div>
    )
}

export default Name
